import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  CatalogTagPicker,
  CatalogTagPickerSchema,
  CatalogTagPickerValidation,
} from './CatalogTagPicker';

export const CatalogTagPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CatalogTagPicker',
    component: CatalogTagPicker,
    schema: CatalogTagPickerSchema,
    validation: CatalogTagPickerValidation,
  }),
);
